import { ga } from './ga';
import { metrika } from './metrika';

export { metrika, ga };


// WEBPACK FOOTER //
// ./src/services/analytics/index.js